import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Image,
  Flex
} from '@chakra-ui/react';
import { ff } from '../theme';

import intro1 from '../assets/intro/people-celebrating.png';
import intro2 from '../assets/intro/collab-card.png';
import intro3 from '../assets/intro/collab-details.png';
import intro4 from '../assets/intro/dining-person.png';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const helpPages = [
    {
      title: "Welcome to FoodFluence",
      content: "We are so excited to have you! Let's quickly go over how the platform works, and what you should expect.",
      image: intro1
    },
    {
      title: "See pending collaborations from restaurants & brands",
      image: intro2
    },
    {
      title: "Accept collaborations",
      image: intro3
    },
    {
      title: "Follow the steps, visit, get rewarded, and post!",
      image: intro4
    }
  ];

  const handleNext = () => {
    if (currentPage < helpPages.length - 1) {
      setCurrentPage(currentPage + 1);
    } else {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setCurrentPage(0);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay />
      <ModalContent 
        height="100svh" 
        width="100vw" 
        margin={0} 
        borderRadius={0} 
        bg={currentPage < 2 ? ff.ink : "white"}
        display="flex"
        flexDirection="column"
      >
        <Flex direction="column" flex={1} pt={5}>
          <ModalHeader textStyle="display" color={currentPage < 2 ? "white" : ff.ink} fontSize={["28px", "36px"]} textAlign="center" pb={0} px={8}>
            {helpPages[currentPage].title}
          </ModalHeader>
          <ModalCloseButton color={currentPage < 2 ? ff.muted : ff.text2} w="44px" h="44px" borderRadius="full" />
          <ModalBody pt={0} flex={1} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Flex direction="column" alignItems="center" justifyContent="center" height="100%" maxWidth="90%">
              {helpPages[currentPage].content && (
                <Text textAlign="center" color={currentPage < 2 ? "whiteAlpha.800" : ff.body} mb={3} fontSize={["15px", "16px"]} lineHeight="1.5">
                  {helpPages[currentPage].content}
                </Text>
              )}
              <Image 
                src={helpPages[currentPage].image} 
                objectFit="contain"
                maxWidth="100%"
                maxHeight="50vh"
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant={currentPage < 2 ? "lime" : "ink"}
              onClick={handleNext}
              width="calc(100% - 20px)"
              maxW="480px"
              mx="auto"
              mb={5}
            >
              {currentPage === 0 ? "Get started" : "Continue"}
            </Button>
          </ModalFooter>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

export default HelpModal;